// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./themes/inspinia/js/plugins/dataTables.buttons/css/buttons.bootstrap.min.css
// module id = 1608
// module chunks = 0